module.exports = __webpack_public_path__ + "media/images/clients/stopwatch-motivation-6e196ca1b7a0ae201602518da2526485.svg";